export const MIME_TYPES = {
  "text/plain": "Textdatei",
  "image/png": "PNG-Bild",
  "image/jpeg": "JPEG-Bild",
  "image/gif": "GIF-Bild",
  "audio/mpeg": "MP3-Audio",
  "video/mp4": "MP4-Video",
  "application/pdf": "PDF-Datei"
};

export const MIME_EXTENSIONS = {
  txt: "text/plain",
  png: "image/png",
  jpeg: "image/jpeg",
  gif: "image/gif",
  mp3: "audio/mpeg",
  mp4: "video/mp4",
  pdf: "application/pdf"
};

export function getPrettyMimeTypeName(type) {
  return MIME_TYPES[type] || type;
}

export default MIME_TYPES;
